const executeCommand = async (endpoint, authToken, command) => {
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'CC-Storefront': process.env.REACT_APP_STOREFRONT_ID,
  }

  if (authToken) {
    headers = {
      ...headers,
      Authorization: `Token ${authToken}`,
    }
  }

  const result = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(command),
    json: true,
  })

  return { command, headers, result }
}

export const initiatePurchase = async ({
  authToken,
  currency,
  trancheId,
  purchaseId,
  storefrontId,
}) => {
  return await executeCommand('/initiate_purchase', authToken, {
    name: 'initiatePurchase',
    purchaseId,
    storefrontId,
    trancheId,
    currency,
  })
}

export const validateIdentity = async (authToken, identity) => {
  return await executeCommand('/validate_identity', authToken, identity)
}

export const claimInvitation = async invitation => {
  return await executeCommand('/claim_invitation', undefined, invitation)
}

export const redeemCode = async (authToken, referralCode) => {
  return await executeCommand('/redeem_code', authToken, referralCode)
}

export const redeemInvitation = async (authToken, invitationToken) => {
  return await executeCommand('/redeem_invitation', authToken, invitationToken)
}

export const signUp = async signUp => {
  return await executeCommand('/register', undefined, signUp)
}



// WEBPACK FOOTER //
// ./src/commands.js